export default __webpack_public_path__ + "static/media/CalendarDate.248251a4.svg";